import React from 'react';

const PRIVACY_URL = 'https://app.termly.io/policy-viewer/policy.html?policyUUID=bdf3687f-046c-403a-8855-7d3c6f53a3e6';
const TERMS_URL   = 'https://app.termly.io/policy-viewer/policy.html?policyUUID=a3abf51d-e155-4c4d-8a02-b2b7f82413d2';

const linkStyle = {
  fontFamily: "'EB Garamond', Georgia, serif",
  fontSize: '13px',
  color: 'rgba(255, 243, 225, 0.22)',
  textDecoration: 'none',
  letterSpacing: '0.03em',
};

const LegalLinks = ({ style }) => (
  <div style={{ display: 'flex', gap: '20px', alignItems: 'center', justifyContent: 'center', ...style }}>
    <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer" style={linkStyle}>
      Privacy Policy
    </a>
    <a href={TERMS_URL} target="_blank" rel="noopener noreferrer" style={linkStyle}>
      Terms of Service
    </a>
  </div>
);

export default LegalLinks;
